module.exports = __webpack_public_path__ + "img/1.208ec042.jpg";